import {
  LayoutDashboard, ShoppingCart, Users, Package, Briefcase,
  Wallet, BarChart3, ShoppingBag, Factory, Truck, Settings,
  Calculator, History, Banknote, FileText, Percent, ScanLine,
  Plus, ClipboardList, Layers, Box, RefreshCcw, Tag, Store,
  Landmark, CreditCard, ArrowLeftRight, TrendingDown, PieChart,
  BarChart, Calendar, Building2, MapPin, Upload, Printer,
  ShieldCheck, FlaskConical, Zap, Database, UserCheck, Scale,
  Activity, ShieldAlert, Bot,
} from 'lucide-react';

/**
 * Estructura de menu reordenada para Gastify.
 * Orden logico para PyME que arranca: lo mas usado arriba.
 *
 * Cada seccion se renderiza como un dropdown/megmenu en la topbar
 * del escritorio, y como un grupo colapsable en el drawer movil.
 */
export const MENU_STRUCTURE = [
  {
    id: 'inicio',
    label: 'Inicio',
    icon: LayoutDashboard,
    items: [
      { id: 'dashboard', label: 'Panel de gestion', icon: LayoutDashboard, isDirect: true },
    ],
  },
  {
    id: 'ventas',
    label: 'Ventas',
    icon: ShoppingCart,
    items: [
      { id: 'ventas-pos', label: 'Punto de venta', icon: Calculator },
      { id: 'ventas-profesional', label: 'Ventas profesional', icon: Briefcase },
      { id: 'ventas-historial', label: 'Historial', icon: History },
      { id: 'caja', label: 'Arqueo de caja', icon: Banknote },
      { id: 'facturacion', label: 'Facturacion', icon: FileText },
      { id: 'presupuestos', label: 'Presupuestos', icon: Calculator },
      { id: 'listas-precios', label: 'Listas de precios', icon: Percent },
    ],
  },
  {
    id: 'clientes',
    label: 'Clientes',
    icon: Users,
    items: [
      { id: 'clientes', label: 'Todos los clientes', icon: Users, isDirect: true },
    ],
  },
  {
    id: 'productos',
    label: 'Productos',
    icon: Package,
    items: [
      { id: 'inventario', label: 'Stock actual', icon: Layers },
      { id: 'productos', label: 'Catalogo de productos', icon: Box },
      { id: 'inventario-transferencia', label: 'Transferencias', icon: RefreshCcw },
      { id: 'inventario-ajuste', label: 'Ajustes de stock', icon: Settings },
      { id: 'inventario-etiquetas', label: 'Imprimir etiquetas', icon: Tag },
    ],
  },
  {
    id: 'compras',
    label: 'Compras',
    icon: Briefcase,
    items: [
      { id: 'compras-ocr', label: 'Escaner IA', icon: ScanLine, badge: 'IA' },
      { id: 'compras-nueva', label: 'Nueva compra', icon: Plus },
      { id: 'pedido-sugerido', label: 'Pedido sugerido', icon: ClipboardList },
      { id: 'compras', label: 'Historial', icon: History },
      { id: 'proveedores', label: 'Proveedores', icon: Briefcase },
    ],
  },
  {
    id: 'finanzas',
    label: 'Finanzas',
    icon: Wallet,
    items: [
      { id: 'bancos', label: 'Bancos', icon: Landmark },
      { id: 'tesoreria-cobranzas', label: 'Cobros', icon: CreditCard },
      { id: 'tesoreria-pagos', label: 'Pagos', icon: Wallet },
      { id: 'tesoreria-transferencia', label: 'Transferencias', icon: RefreshCcw },
      { id: 'gastos', label: 'Gastos', icon: TrendingDown },
      { id: 'conciliacion-bancaria', label: 'Concil. bancaria', icon: RefreshCcw },
      { id: 'conciliacion-ctas-ctes', label: 'Concil. ctas. ctes.', icon: ArrowLeftRight },
    ],
  },
  {
    id: 'analisis',
    label: 'Analisis',
    icon: BarChart3,
    items: [
      { id: 'gestion-costos', label: 'Gestion de costos', icon: Calculator },
      { id: 'rentabilidad-ventas', label: 'Rentabilidad', icon: PieChart },
      { id: 'flujo-fondos', label: 'Flujo de fondos', icon: BarChart },
      { id: 'reportes-ctas-ctes', label: 'Cuentas corrientes', icon: Wallet },
      { id: 'reportes-impositivos', label: 'Reportes impositivos', icon: Landmark },
    ],
  },
  {
    id: 'tienda',
    label: 'Tienda',
    icon: ShoppingBag,
    items: [
      { id: 'pedidos-web', label: 'Pedidos web', icon: ShoppingBag },
      { id: 'tienda-config', label: 'Config. tienda', icon: Store },
    ],
  },
  {
    id: 'produccion',
    label: 'Produccion',
    icon: Factory,
    items: [
      { id: 'produccion-registrar', label: 'Registrar produccion', icon: Zap },
      { id: 'pedidos-produccion', label: 'Pedidos de produccion', icon: ClipboardList },
      { id: 'recetas', label: 'Recetas', icon: FlaskConical },
      { id: 'produccion-historial', label: 'Historial', icon: History },
      { id: 'produccion-distribucion', label: 'Distribucion de costos', icon: TrendingDown },
    ],
  },
  {
    id: 'config',
    label: 'Configuracion',
    icon: Settings,
    items: [
      { id: 'empresa-datos', label: 'Mi empresa', icon: Building2 },
      { id: 'sitios', label: 'Sucursales / Sitios', icon: MapPin },
      { id: 'permisos', label: 'Usuarios y roles', icon: UserCheck },
      { id: 'categorias', label: 'Categorias', icon: Tag },
      { id: 'unidades-medida', label: 'Unidades de medida', icon: Scale },
      { id: 'metodos-cobro', label: 'Metodos de cobro', icon: CreditCard },
      { id: 'condiciones-pago', label: 'Condiciones de pago', icon: Calendar },
      { id: 'tipos-comprobante', label: 'Tipos de comprobante', icon: FileText },
      { id: 'config-facturacion', label: 'Facturacion (ARCA)', icon: ShieldCheck },
      { id: 'config-reportes', label: 'Impresion / Tickets', icon: Printer },
      { id: 'presupuestos-config', label: 'Config. presupuestos', icon: FileText },
      { id: 'config-logistica', label: 'Config. logistica', icon: Truck },
      { id: 'config-sistema-datos', label: 'Sistema y datos', icon: Database },
      { id: 'importaciones', label: 'Importaciones', icon: Upload },
      { id: 'logs', label: 'Logs', icon: FileText },
      { id: 'chatbot', label: 'IA Asistente', icon: Bot },
    ],
  },
];

/**
 * Seccion extra solo para el master admin (adpenia@gmail.com).
 * Se acopla al final del menu cuando isMasterAdmin = true.
 */
export const SUPER_ADMIN_SECTION = {
  id: 'super-admin',
  label: 'Super Admin',
  icon: ShieldAlert,
  items: [
    { id: 'super-admin-stats', label: 'Metricas globales', icon: Activity },
    { id: 'super-admin-empresas', label: 'Gestion empresas', icon: ShieldAlert },
    { id: 'super-admin-pricing', label: 'Precios y planes', icon: CreditCard },
    { id: 'super-admin-presets', label: 'Rubros y Presets', icon: Layers },
    { id: 'super-admin-suscripciones', label: 'Suscripciones y cobros', icon: Activity },
    { id: 'super-admin-adopcion', label: 'Adopcion', icon: Activity },
    { id: 'super-admin-auditoria', label: 'Bitacora de sesiones', icon: Users },
    { id: 'super-admin-sentry', label: 'Consola Sentry', icon: ShieldAlert },
    // Cobro 100% Mercado Pago / AstroPay → sin comprobantes manuales.
    // Si en el futuro rehabilitás transferencias, descomentá la línea de abajo.
    // { id: 'super-admin-comprobantes', label: 'Comprobantes pago', icon: FileText },
    { id: 'super-admin-demo-requests', label: 'Solicitudes demo', icon: Users },
  ],
};

/**
 * Devuelve la estructura completa, con super admin si corresponde.
 */
export const getMenuStructure = (isMasterAdmin) => {
  if (isMasterAdmin) return [...MENU_STRUCTURE, SUPER_ADMIN_SECTION];
  return MENU_STRUCTURE;
};
